import {
  centroid,
  normalizePoint,
} from 'features/Responder/features/Zones';

const toRadians = (value) => (value * Math.PI) / 180;

export const distanceMeters = (a, b) => {
  if (!a || !b) return Number.POSITIVE_INFINITY;
  const lat1 = toRadians(a.lat);
  const lat2 = toRadians(b.lat);
  const dLat = lat2 - lat1;
  const dLng = toRadians(b.lng - a.lng);
  const sinLat = Math.sin(dLat / 2);
  const sinLng = Math.sin(dLng / 2);
  const hav =
    sinLat * sinLat + Math.cos(lat1) * Math.cos(lat2) * sinLng * sinLng;
  return 2 * 6371000 * Math.asin(Math.min(1, Math.sqrt(hav)));
};

export const parseTimestamp = (value) => {
  if (!value) return null;
  const time = new Date(value).getTime();
  return Number.isNaN(time) ? null : time;
};

export const normalizeLatLng = (loc) => {
  if (!loc) return null;
  const lat = Number(loc.lat ?? loc.latitude ?? loc.coords?.[0] ?? loc.coordinates?.[0]);
  const lng = Number(loc.lng ?? loc.longitude ?? loc.coords?.[1] ?? loc.coordinates?.[1]);
  return Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : null;
};

export const normalizeGeometryPoints = (geometry) => {
  const raw = geometry?.points ?? geometry?.coord ?? geometry?.polygon ?? [];
  return Array.isArray(raw) ? raw.map((pt) => normalizePoint(pt)).filter(Boolean) : [];
};

export const resolveStopLatLng = (stop) => {
  if (!stop) return null;
  const lat = Number(
    stop.lat ??
      stop.latitude ??
      stop.location?.lat ??
      stop.location?.latitude ??
      stop.location?.coords?.[0] ??
      stop.location?.coordinates?.[0] ??
      stop.coordinates?.[0] ??
      stop.coords?.[0],
  );
  const lng = Number(
    stop.lng ??
      stop.longitude ??
      stop.location?.lng ??
      stop.location?.longitude ??
      stop.location?.coords?.[1] ??
      stop.location?.coordinates?.[1] ??
      stop.coordinates?.[1] ??
      stop.coords?.[1],
  );
  if (Number.isFinite(lat) && Number.isFinite(lng)) return { lat, lng };
  const points = normalizeGeometryPoints(stop?.geometry);
  if (points.length) return centroid(points) || points[0];
  return null;
};


